export const WEMBII_BRAND = "#0B65C2";

export const WEMBII_BRAND_LIGHT = "#38B6FF";

export const WEMBII_BRAND_DARK = "#0954A0";

export const CRM_CHART_THEME = [
  WEMBII_BRAND,
  WEMBII_BRAND_LIGHT,
  WEMBII_BRAND_DARK,
  "#22c55e",
  "#f59e0b",
  "#8b5cf6",
  "#06b6d4",
  "#ec4899",
];
